import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../reduxService';
import * as BeMaccaferriIdentityHelper from '../../api/identity/BeMaccaferriIdentityHelper';
import { isProductionEnv } from '../../utils/utils';
import { IUser } from '../../enum/user';

const initialState: IInitialState<IUser> = {
    initialState: true,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchUser.pending, state => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            })
            .addCase(fetchLogout.fulfilled, state => {
                state.data = undefined;
                state.pending = false;
                state.error = undefined;
                state.initialState = true;
            });
    },
});

export const fetchUser = createAsyncThunk('EDesignApi/GetUser', async (_undefined, { rejectWithValue }) => {
    try {
        let user: IUser;
        if (isProductionEnv()) {
            const resUserName = await BeMaccaferriIdentityHelper.getUserAsync();
            user = {
                lastName: resUserName.lastName,
                firstName: resUserName.firstName,
                email: resUserName.email,
                isAdmin: resUserName.isAdmin,
            };
        } else {
            user = {
                lastName: '',
                firstName: 'development user',
                email: 'developmentUser@email.com',
                isAdmin: true,
            };
        }
        return user;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export const fetchLogout = createAsyncThunk('EDesignApi/Logout', async (_undefined, { rejectWithValue }) => {
    try {
        await BeMaccaferriIdentityHelper.logoutAsync();
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
